import { always } from "asrt";
export function clearElement(element) {
    while (element.hasChildNodes()) {
        always(element.lastChild != null, "[tDN-fwY-XRf]");
        element.removeChild(element.lastChild);
    }
}
